@for (toast of toasts | async; track toast.id) {
  <div animate.enter="toast-enter" animate.leave="toast-leave" role="status">
    <app-toast [toast]="toast" (close)="close(toast.id)" />
  </div>
}
